(function() {
  angular.module('registration')
  .factory('dsoRegistrationService', function() {
    let dsoRegistrationModel = {};
    return {
      dsoRegistrationModel: function(_dsoRegModel) {
        if(_dsoRegModel !== undefined) {
          dsoRegistrationModel = angular.copy(_dsoRegModel);
        }
        return dsoRegistrationModel;
      },
      init: function() {
        dsoRegistrationModel = {};
        this.requestToken = undefined;
      },
      dsoProfile: function() {
        return _.pick(_.merge({}, dsoRegistrationModel), [
          'name',
          'taxIds',
          'contactFirstName',
          'contactLastName',
          'email',
          'phone',
          'address1',
          'address2',
          'city',
          'state',
          'zip',
          'providerContactFirstName',
          'providerContactLastName',
          'providerContactEmail',
          'providerContactPhone',
        ]);
      }
    };
  });
})();
